import ApiService from "../../../core/service/ApiService";
import Helper from "../../../core/Helper";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";
import { PERMISSIONS, useUser } from "../../../core/context/UserContext";

const PERMISSION_BY_VIEW = {
    entitlement: PERMISSIONS.ENTITLEMENT_EXPORT,
    appointment: PERMISSIONS.EXPORT_APPOINTMENTS,
    accounting: PERMISSIONS.EXPORT_APPOINTMENTS,
};

/**
 * Randevu listesi sekmelerinin Excel dışa aktarımı — uygulanan filtreyle (queryModel.filter).
 * Masaüstünde filtre çubuğundaki Excel düğmesi, mobilde grid araç çubuğundaki İşlemler menüsü kullanır.
 */
export default function useAppointmentExcelExport(view) {
    const { queryModel } = useDataGrid();
    const { hasPermission } = useUser();

    const canExport = !!view && hasPermission(PERMISSION_BY_VIEW[view]);

    const exportExcel = async () => {
        const payload = {
            ...queryModel.filter,
            startDate: Helper.Date.beginOfDay(queryModel.filter.startDate),
            endDate: Helper.Date.endOfDay(queryModel.filter.endDate),
        };
        let res;
        if (view === 'entitlement') res = await ApiService.Entitlement.GetExcelEntitlements(payload);
        else if (view === 'appointment') res = await ApiService.Appointment.GetExcelAppointments(payload);
        else if (view === 'accounting') res = await ApiService.Accounting.GetExcelAppointmentAccounting(payload);

        if (res && res.success) {
            Helper.File.saveFile({ blobLink: res.data, fileName: res.fileName })
        }
    }

    return { canExport, exportExcel };
}
